module.exports = __webpack_public_path__ + "img/Daniel.d1afe1d5.jpg";